export const CHAT_DRAFT_STORAGE_KEY = 'curious.chat.draft';
export const CHAT_INSERT_EVENT = 'curious:chat-insert';

export const writeChatDraft = (content: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  const trimmed = content.trim();
  if (!trimmed) {
    return;
  }
  window.sessionStorage.setItem(CHAT_DRAFT_STORAGE_KEY, trimmed);
  window.dispatchEvent(new CustomEvent<string>(CHAT_INSERT_EVENT, { detail: trimmed }));
};

export const consumeChatDraft = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const draft = window.sessionStorage.getItem(CHAT_DRAFT_STORAGE_KEY);
  if (draft) {
    window.sessionStorage.removeItem(CHAT_DRAFT_STORAGE_KEY);
    return draft;
  }
  return null;
};
